"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[1347],{

/***/ 29152:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ LimitedDropsBanner_LimitedDropsBanner)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/modules/priceSelection/index.tsx
var priceSelection = __webpack_require__(19792);
// EXTERNAL MODULE: ./src/components/layout/Bone/Bone.tsx + 1 modules
var Bone = __webpack_require__(10430);
// EXTERNAL MODULE: ./src/components/dataDisplay/HeroMediaBlock/HeroMediaBlock.tsx + 1 modules
var HeroMediaBlock = __webpack_require__(68155);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/dataDisplay/BackgroundImage/BackgroundImage.tsx + 1 modules
var BackgroundImage = __webpack_require__(26713);
// EXTERNAL MODULE: ./src/compositions/StyledTimer/StyledTimer.tsx + 1 modules
var StyledTimer = __webpack_require__(93735);
;// CONCATENATED MODULE: ./src/compositions/banners/LimitedDropsBanner/messages.ts
/* harmony default export */ const LimitedDropsBanner_messages = ({
    title: {
        en: "Limited drop"
    },
    soldOutTitle: {
        en: "SOLD OUT!"
    },
    saleHeadline: {
        en: "Exclusive offer, available{breakLine}for {hours} hours only"
    },
    burndownHeadline: {
        en: "Exclusive offer, available{breakLine}for limited time"
    },
    soldOutHeadline: {
        en: "This exclusive drop sold out quick.<br /> Don’t miss the next one."
    },
    saleOffer: {
        en: "Offer valid while supplies last. This offer can't be<br /> customized and is only available for a limited time."
    },
    nextSaleDropDate: {
        en: 'Save the date:<br class="onlyMobile" /> <span class="font-bold">Next drop:<br class="onlyMobile" /> {date} EST</span>'
    }
});

// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardLimitedDrop/ProductCardLimitedDrop.tsx
var ProductCardLimitedDrop = __webpack_require__(70260);
;// CONCATENATED MODULE: ./src/compositions/banners/LimitedDropsBanner/components/MobileSaleLimitedDropBanner/images/background.jpeg
const background_namespaceObject = __webpack_require__.p + "images/background_77f102.jpeg";
;// CONCATENATED MODULE: ./src/compositions/banners/LimitedDropsBanner/components/MobileSaleLimitedDropBanner/MobileSaleLimitedDropBanner.tsx










const MobileSaleLimitedDropBanner = (props)=>{
    const { className, data, size, withoutLink, onCardClick, onBannerClick, onCountdownExpired, placement } = props;
    const isShortHeight = size === "cut-height";
    let content, products;
    if (!isShortHeight) {
        products = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx/* default */.Z)("inline-grid auto-cols-[176rem] grid-flow-col gap-16 px-8", data?.isSoldOut ? "mt-32" : "mt-24"),
            children: data?.products.map((product)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardLimitedDrop/* default */.ZP, {
                    data: product,
                    withoutLink: withoutLink,
                    onLinkClick: onBannerClick,
                    buttonProps: data?.isSoldOut ? ProductCardLimitedDrop/* outOfStockButtonProps */.ps : {
                        onClick: onCardClick,
                        metadata: {
                            placement
                        }
                    }
                }, product.id))
        });
    }
    if (data?.isSoldOut) {
        content = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)("text-center", isShortHeight ? "pb-48 pt-32" : "py-24"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    style: "h3",
                    message: LimitedDropsBanner_messages.soldOutTitle,
                    html: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mt-24 font-normal",
                    style: "p1",
                    message: LimitedDropsBanner_messages.soldOutHeadline,
                    html: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mt-24 w-full bg-gold-50 px-24 py-8 text-center uppercase",
                    style: "p1",
                    color: "white",
                    message: {
                        ...LimitedDropsBanner_messages.nextSaleDropDate,
                        values: {
                            date: data?.nextDropDate
                        }
                    },
                    html: true
                }),
                products
            ]
        });
    } else {
        const title = /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
            className: "px-8",
            style: "h3",
            message: LimitedDropsBanner_messages.title,
            "data-testid": "limitedDropBannerTitle",
            html: true
        });
        const headlineMessage = data?.hasReachedBurndown ? LimitedDropsBanner_messages.burndownHeadline : LimitedDropsBanner_messages.saleHeadline;
        const headline = /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
            style: "p1",
            className: isShortHeight && "mt-12",
            message: {
                ...headlineMessage,
                values: {
                    breakLine: isShortHeight ? " " : "<br />",
                    hours: data?.hoursUntilBurndown
                }
            },
            "data-testid": "limitedDropBannerHeadline",
            html: true
        });
        const timer = !data?.hasReachedBurndown && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimer/* default */.Z, {
            className: isShortHeight ? "mt-16" : "ml-12",
            size: 36,
            backgroundColor: "gray-10",
            onExpired: onCountdownExpired,
            cookieName: null,
            initialTime: data?.expirationTime,
            "data-testid": "limitedDropBannerTimer",
            withHours: true
        });
        if (isShortHeight) {
            content = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-40 pt-48 text-center",
                children: [
                    title,
                    headline,
                    timer
                ]
            });
        } else {
            content = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-16 pt-32",
                children: [
                    title,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-12 flex w-full items-center px-8",
                        children: [
                            headline,
                            timer
                        ]
                    }),
                    products,
                    !withoutLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: "mt-24",
                        size: 56,
                        title: messages/* default */.Z.shopNow,
                        width: 280,
                        to: data?.link,
                        onClick: onBannerClick,
                        fullWidthOnMobile: true,
                        "data-testid": "limitedDropBannerActionButton"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        className: "mt-16 w-full text-center",
                        style: "p5",
                        message: LimitedDropsBanner_messages.saleOffer,
                        "data-testid": "limitedDropBannerSaleOffer",
                        html: true
                    })
                ]
            });
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* default */.Z, {
        className: className,
        src: background_namespaceObject,
        "data-testid": "limitedDropBanner",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainer/* default */.Z, {
            children: content
        })
    });
};
/* harmony default export */ const MobileSaleLimitedDropBanner_MobileSaleLimitedDropBanner = (MobileSaleLimitedDropBanner);

// EXTERNAL MODULE: ./src/components/layout/WidthContainerCompensator/WidthContainerCompensator.tsx
var WidthContainerCompensator = __webpack_require__(34626);
;// CONCATENATED MODULE: ./src/compositions/banners/LimitedDropsBanner/components/DesktopSaleLimitedDropBanner/images/background.jpeg
const DesktopSaleLimitedDropBanner_images_background_namespaceObject = __webpack_require__.p + "images/background_dcd875.jpeg";
;// CONCATENATED MODULE: ./src/compositions/banners/LimitedDropsBanner/components/DesktopSaleLimitedDropBanner/DesktopSaleLimitedDropBanner.tsx










const DesktopSaleLimitedDropBanner = (props)=>{
    const { className, data, size, withoutLink, onCardClick, onBannerClick, onCountdownExpired, placement } = props;
    const isShortHeight = size === "cut-height";
    const isShopNowButtonVisible = !withoutLink && !isShortHeight && !data?.isSoldOut;
    let leftColumn, buttonProps;
    if (data?.isSoldOut) {
        buttonProps = ProductCardLimitedDrop/* outOfStockButtonProps */.ps;
        leftColumn = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: isShortHeight && "mt-36",
                    style: "h1",
                    message: LimitedDropsBanner_messages.soldOutTitle,
                    html: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mt-24 font-normal",
                    style: "sh1",
                    message: LimitedDropsBanner_messages.soldOutHeadline,
                    html: true
                }),
                data?.isCurrentSale && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mt-24 w-full bg-gold-50 py-8 text-center uppercase",
                    style: "p1",
                    color: "white",
                    message: {
                        ...LimitedDropsBanner_messages.nextSaleDropDate,
                        values: {
                            date: data?.nextDropDate
                        }
                    },
                    html: true
                })
            ]
        });
    } else {
        buttonProps = {
            onClick: onCardClick,
            metadata: {
                placement
            }
        };
        const leftColumnContent = data?.hasReachedBurndown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
            className: "mt-12",
            style: "sh2",
            message: {
                ...LimitedDropsBanner_messages.burndownHeadline,
                values: {
                    breakLine: "<br />"
                }
            },
            "data-testid": "limitedDropBannerHeadline",
            html: true
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mt-12",
                    style: "sh2",
                    message: {
                        ...LimitedDropsBanner_messages.saleHeadline,
                        values: {
                            breakLine: "<br />",
                            hours: data?.hoursUntilBurndown
                        }
                    },
                    "data-testid": "limitedDropBannerHeadline",
                    html: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimer/* default */.Z, {
                    className: "mt-32",
                    size: 56,
                    backgroundColor: "gray-10",
                    onExpired: onCountdownExpired,
                    cookieName: null,
                    initialTime: data?.expirationTime,
                    "data-testid": "limitedDropBannerTimer",
                    withHours: true
                })
            ]
        });
        leftColumn = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    style: "h1",
                    message: LimitedDropsBanner_messages.title,
                    "data-testid": "limitedDropBannerTitle",
                    html: true
                }),
                leftColumnContent,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: (0,clsx/* default */.Z)("absolute", isShortHeight ? "bottom-24" : "bottom-48"),
                    style: "p5",
                    message: LimitedDropsBanner_messages.saleOffer,
                    "data-testid": "limitedDropBannerSaleOffer",
                    html: true
                })
            ]
        });
    }
    const content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroMediaBlock/* default */.Z, {
        className: (0,clsx/* default */.Z)(className, "relative"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroMediaBlock/* default */.Z.Image, {
                src: DesktopSaleLimitedDropBanner_images_background_namespaceObject,
                height: isShortHeight ? 380 : 544
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
                className: "absolute inset-0 flex h-full w-full items-center justify-between px-60",
                "data-testid": "limitedDropBanner",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "basis-1/2",
                        children: leftColumn
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "basis-1/2 pl-60 text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inline-grid auto-cols-[216rem] grid-flow-col gap-16",
                                children: data?.products.map((product)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardLimitedDrop/* default */.ZP, {
                                        data: product,
                                        buttonProps: buttonProps,
                                        onLinkClick: onBannerClick,
                                        withoutLink: withoutLink,
                                        withoutButton: isShortHeight
                                    }, product.id))
                            }),
                            isShopNowButtonVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "mt-24",
                                size: 56,
                                title: messages/* default */.Z.shopNow,
                                width: 280,
                                to: data?.link,
                                onClick: onBannerClick,
                                "data-testid": "limitedDropBannerActionButton"
                            })
                        ]
                    })
                ]
            })
        ]
    });
    if (size === "cut-width") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainer/* default */.Z, {
            className: "w-full",
            ignore: size !== "cut-width",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainerCompensator/* default */.Z, {
                children: content
            })
        });
    }
    return content;
};
/* harmony default export */ const DesktopSaleLimitedDropBanner_DesktopSaleLimitedDropBanner = (DesktopSaleLimitedDropBanner);

// EXTERNAL MODULE: ./local_modules/date/index.ts
var date = __webpack_require__(64895);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/modules/limitedDrops/useLimitedDropSale.ts + 1 modules
var useLimitedDropSale = __webpack_require__(78721);
;// CONCATENATED MODULE: ./src/compositions/banners/LimitedDropsBanner/util/useLimitedDropsBanner.ts




const useLimitedDropsBanner = (param)=>{
    let { id } = param;
    const [isCountdownExpired, setIsCountdownExpired] = (0,react.useState)(false);
    const { data, isFetching } = (0,useLimitedDropSale/* default */.Z)({
        id
    });
    const onCountdownExpired = (0,react.useCallback)(()=>{
        setIsCountdownExpired(true);
    }, []);
    const modifiedData = (0,react.useMemo)(()=>{
        if (!data) {
            return null;
        }
        return {
            ...data,
            link: links/* default */.ZP.currentLimitedDrop,
            startDate: (0,date/* default */.ZP)(data?.startDate).tz("America/New_York").format("MMMM Do [at] hA"),
            nextDropDate: (0,date/* default */.ZP)(data?.nextDropDate).tz("America/New_York").format("MMMM Do [at] hA"),
            isSoldOut: data?.isSoldOut || isCountdownExpired
        };
    }, [
        data,
        isCountdownExpired
    ]);
    return {
        data: modifiedData,
        isFetching,
        onCountdownExpired
    };
};
/* harmony default export */ const util_useLimitedDropsBanner = (useLimitedDropsBanner);

;// CONCATENATED MODULE: ./src/compositions/banners/LimitedDropsBanner/LimitedDropsBanner.tsx










const LimitedDropsBanner = (props)=>{
    const { id, className, size, placement, withoutLink = false } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { isFetching, data, onCountdownExpired } = util_useLimitedDropsBanner({
        id
    });
    if (isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroMediaBlock/* default */.Z, {
            wideMB: false,
            wideMT: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
                bgColor: "light-beige",
                aspect: isMobile ? 416 / 605 : 1440 / 544
            })
        });
    }
    if (!data) {
        return null;
    }
    const onCardClick = ()=>(0,analytics/* track */.j)("Banner click", {
            placement,
            content: "Limited drop",
            action: "Add to cart",
            ...data?.metadata
        });
    const onBannerClick = ()=>(0,analytics/* track */.j)("Banner click", {
            placement,
            content: "Limited drop",
            link: data?.link,
            action: "link",
            ...data?.metadata
        });
    const bannerProps = {
        className,
        size,
        data,
        withoutLink,
        onCountdownExpired,
        onCardClick,
        onBannerClick,
        placement
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(priceSelection/* PriceSelectionProvider */.CT, {
        channel: priceSelection/* priceChannels */.GW.limitedDropSale,
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSaleLimitedDropBanner_MobileSaleLimitedDropBanner, {
            ...bannerProps
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopSaleLimitedDropBanner_DesktopSaleLimitedDropBanner, {
            ...bannerProps
        })
    });
};
/* harmony default export */ const LimitedDropsBanner_LimitedDropsBanner = (LimitedDropsBanner);


/***/ })

}]);